import React from 'react';
import { useIntl } from 'react-intl';
import { Typography, Box } from '@mui/material';
import RegistrationWrapper from './RegistrationWrapper';

const RegistrationCompleteLandingPage = () => {
  const { formatMessage } = useIntl();

  return (
    <RegistrationWrapper>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        py={6}
        px={3}
        data-testid="registration-complete-landing"
      >
        <Typography variant="h4" component="h1" gutterBottom sx={{ color: 'white', fontWeight: 600 }} data-testid="registration-complete-title">
          {formatMessage({ id: 'registration-complete.title' })}
        </Typography>

        <Typography variant="body1" sx={{ color: 'white', maxWidth: 420, mt: 2 }} data-testid="registration-complete-message">
          {formatMessage({ id: 'registration-complete.message' })}
        </Typography>
      </Box>
    </RegistrationWrapper>
  );
};

export default RegistrationCompleteLandingPage;
